<template>
  <el-header height="auto">
      <div class="hdr-tit" :class="$route.path =='/manual-booking-flow/book-appointment/bupa-offline-packages' || '/manual-booking-flow/book-appointment/hospital_list'?'hdr-tit-inline':''">
        <el-button size="small" v-if="$route.path == '/manual-booking-flow/book-appointment/bupa-offline-packages'" class="back-btn" plain @click="$router.go(-1)"><i class="icon-arrow-left h2"></i></el-button>
        <el-button size="small" v-if="$route.path == '/manual-booking-flow/book-appointment/hospital_list'" class="back-btn" plain @click="$router.go(-1)"><i class="icon-arrow-left h2"></i></el-button>
        <h5 class="primary-color" v-if="$route.path == '/manual-booking-flow/book-appointment/bupa-offline-packages' || '/manual-booking-flow/book-appointment/hospital_list'"> {{ userdata && userdata.client === "Bupa" ? "" : dashboardTitle }}</h5> <!--<h6>King Fahad Medical City</h6>-->
      </div>
        
      <div class="sa-menu-bar">
        <div v-if="functionid['152']!=undefined" class="sa-sanar-ai" @click="sanarAi">
          <i class="icon-chat-bot"></i>
          Sanar AI
        </div>
        <notification />
        <div v-if="eventid['1387']!==undefined" class="sa-notific-emp">
            <img :src="imageUrl" class="" @click="gotoEmpStatus"/>
            <p> {{empStatCount}} </p>
        </div>
        <el-menu class="el-menu-demo" mode="horizontal">
          <el-menu-item v-if="$store.getters['uicomponents/isEmployees'] && $store.getters['employees/userTypeName']">
              <router-link class="add-btn" tag="button" :to="{ path:'/employees/'+$store.getters['employees/userTypeName']+'/add'}">Add {{$store.getters['employees/userTypeName'] | capitalize}}</router-link>
          </el-menu-item>
            <!-- <el-menu-item class="left" v-if="$store.getters['uicomponents/isAccounts']">
              <router-link class="add-btn" tag="button" :to="{ path: '/accounts/add-bill'}">Add Bill</router-link>
            </el-menu-item> -->
          
          <!--  <el-menu-item v-if="$store.getters['masters/setemp']&&$store.getters['uicomponents/isMaster']&&$store.getters.masterTypeName&&$store.getters.actionType">
              <router-link class="add-btn" tag="button" :to="{ path: '/master/'+$store.getters.masterTypeName+'/'+$store.getters['masters/geturl']}" >
                                      {{$store.getters['masters/setemp'].employee?$store.getters['masters/setemp'].employee==4?'Add Test':$store.getters['masters/setemp'].employee==3?' Add Tasks':'Add Treatment':$store.getters['masters/geturl']}}
                                </router-link>
            </el-menu-item>
            <el-menu-item v-if="$store.getters['uicomponents/isMaster'] && $store.getters.masterTypeName =='servietype_task' &&$store.getters['masters/setemp']&&$store.getters['masters/setemp'].employee==4">
              <router-link class="add-btn2" tag="button" :to="{ path: '/master/'+$store.getters.masterTypeName+'/addPackage'}">Add a new Package</router-link>
            </el-menu-item> -->
            <!-- <el-menu-item v-if="$store.getters['uicomponents/isService']">
              <router-link class="add-btn2" tag="button" :to="{ path: '/services/'+$store.getters.serviceTypeName+'/add'}">Add {{$store.getters.serviceTypeName=='tasks'?'Task':$store.getters.serviceTypeName=='treatments'?'Treatment':$store.getters.serviceTypeName=='treatment'?'Treatment':$store.getters.serviceTypeName=='tests'?'Test':'Packages'}}</router-link>
              <router-link class="add-btn2" tag="button" :to="{ path: '/services/'+$store.getters.serviceTypeName+'/add'}">Add Price</router-link>
            </el-menu-item>  -->
            <el-menu-item v-if="$store.getters['uicomponents/isMaster']&&$store.getters.masterTypeName!='department'">
              <router-link class="add-btn2" tag="button" :to="{ path: '/master/'+$store.getters.masterTypeName+'/add'}">Add {{$store.getters.masterTypeName=='tasks'?'Task':$store.getters.masterTypeName=='treatments'?'Treatment':$store.getters.masterTypeName=='treatment'?'Treatment':$store.getters.masterTypeName=='tests'?'Test':'Packages'}}</router-link>
            </el-menu-item> 
            <el-submenu index="4" popper-class="profile-text" class="profile">
              <template slot="title">
              <span class="profile-men-cnt"><h6>{{userdata.name}}</h6> {{userdata.email}}</span>
              <img src="/static/images/user.svg" class="avtar"></template>
            <el-menu-item index="2-1" @click="changpassword()">Change Password</el-menu-item>
            <el-menu-item index="2-1" @click.native="logout()">Logout</el-menu-item>
          </el-submenu>
        </el-menu>
      </div>

      

  </el-header>
</template>
<script>
// import { mapState } from 'vuex'
import Notification from "../../components/notification/Notification.vue"
import config from '../../../config/endpoints'
import vueCookie from "vue-cookie"

export default {
  // computed: mapState(['dashboardTitle']),
  name: "HeaderStrip",
  components: {
    Notification
  },
  mounted () {
    this.getEmpStatusCount()
  },
  data() {
    return {
      open: false,
      userData: null,
      imageUrl: "/static/images/profile-notification.svg"
    }
  },
  methods: {
    gotoEmpStatus () {
      this.$router.push({
          path: "/notifications/employee"
      });
    },
    async getEmpStatusCount () {
      await this.$store.dispatch('common/GET_EMPNOTIFICATION', {})
    },
    sanarAi: function() {
      const redirectUrl =`${config.sanar_ai}redirect/${vueCookie.get("token") || undefined}`;
      window.open(redirectUrl,'_blank');
    },
    logout: function() {
      this.$store.dispatch("auth/LOGOUT").then(() => {
        localStorage.setItem('userdetails',null)
        this.$router.push("/login");
      });
      this.$store.commit('auth/setNavigation', false)
    },
    changpassword: function() {
      this.$router.push("/change-password");
    }
  },

  filters: {
    capitalize: function(value) {
      if (!value) return "";
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    }
  },
  computed: {
    eventid(){
      this.eventsData = JSON.parse(localStorage.getItem("eventids"));
      return this.eventsData;
    },
    dashboardTitle() {
      return this.$store.getters["getDashboardTitle"];
    },
    userdata() {
      return JSON.parse(localStorage.getItem("userdetails"));
    },
    functionid() {
      this.functionData = JSON.parse(localStorage.getItem("fnids"));
      return this.functionData;
    },
    empStatCount (){
      if(this.$store.getters['common/getEmpCount']) {
          return this.$store.getters['common/getEmpCount']
      }
    }
  },
};
</script>
<style scoped>
.sa-sanar-ai {color: var(--sa-light);display: flex;align-items: center;gap:5px;background: var(--sa-primary);padding: 5px 10px;border-radius: 5px;cursor: pointer;}
.sa-sanar-ai i {font-size: 20px;color: var(--sa-green);}

</style>



// WEBPACK FOOTER //
// src/components/common/HeaderStrip.vue